// extracted by mini-css-extract-plugin
export var baseButton = "_pg-0";
export var controlsArrowKeys = "_pg-1";
export var controlsResetButton = "_pg-2";
export var lightGameButton = "_pg-4 _pg-0";
export var playAgainButton = "_pg-5 _pg-0";
export var startGameButton = "_pg-3 _pg-0";